import { IModalidade } from "interfaces/eventos";
import api from "./api";

/**
 * Criar uma nova modalidade
 * @param {Omit<IModalidade, "id">} modalidade - Dados da modalidade a ser criada
 * @returns {Promise<IModalidade>} - Dados da modalidade criada
 * @throws {Error} - Lan a um erro se a comunica o com o servidor falhar
 */
export async function saveModalidade(
  modalidade: Omit<IModalidade, "id">
): Promise<IModalidade> {
  try {
    const { data, status } = await api.post("/modalidades", modalidade);

    if (status === 201) {
      return data; // Retorna o dado da modalidade criada
    }

    throw new Error("Erro ao criar modalidade");
  } catch (error: any) {
    throw new Error(error?.message ?? "Erro ao criar modalidade");
  }
}

/**
 * Editar uma modalidade
 * @param {number} id - ID da modalidade a ser editada
 * @param {IModalidade} modalidade - Dados da modalidade a ser editada
 * @returns {Promise<IModalidade>} - Dados da modalidade editada
 * @throws {Error} - Lança um erro se a comunicação com o servidor falhar
 */
export async function editModalidade(
  id: number,
  modalidade: IModalidade
): Promise<IModalidade> {
  try {
    const { data, status } = await api.put<IModalidade>(
      `/modalidades/${id}`,
      modalidade
    );
    if (status === 200) {
      return data;
    }
    throw new Error("Erro ao editar modalidade");
  } catch (error) {
    throw new Error("Erro ao editar modalidade");
  }
}

/**
 * Excluir uma modalidade
 * @param {number} id - ID da modalidade a ser excluida
 * @returns {Promise<void>} - Não retorna nada
 * @throws {Error} - Lança um erro se a comunicão com o servidor falhar
 */
export async function deleteModalidade(id: number): Promise<void> {
  try {
    await api
      .delete(`/modalidades/${id}`)
      .then(({ data, status }) => {
        if (status === 200) {
          return;
        }
        throw new Error(data.message);
      })
      .catch((error: any) => {
        throw new Error(error.message);
      });
  } catch (error) {
    throw new Error("Erro ao excluir modalidade");
  }
}

/**
 * Listar todas as modalidades
 * @returns {Promise<IModalidade[]>} - Lista de modalidades
 * @throws {Error} - Lança um erro se a comunicação com o servidor falhar
 */
export async function listAllModalidades(): Promise<IModalidade[]> {
  try {
    const { data, status } = await api.get("/modalidades");
    if (status === 200) {
      return data;
    }
    throw new Error(data.message);
  } catch (error: any) {
    // Erro ao buscar modalidades
    throw new Error(error.message || "Erro ao buscar modalidades");
  }
}
